module.exports = __webpack_public_path__ + "img/ApparatebauEFZ-CR-1480.d040e365.jpg";